import { render } from "./SurveyClient.vue?vue&type=template&id=1b4f24ec"
import script from "./SurveyClient.vue?vue&type=script&lang=js"
export * from "./SurveyClient.vue?vue&type=script&lang=js"

import "./SurveyClient.vue?vue&type=style&index=0&id=1b4f24ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__